// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import {
  type MarketSummary,
  type MarketSummaryWireFormat,
  NewMarketSummary,
} from '../MarketSummary/MarketSummary';

export class Division {
  readonly id: string;
  readonly name: string;
  readonly markets: MarketSummary[];

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
    this.markets = (data.markets ?? []).map((markets: any) => NewMarketSummary(markets));
  }

  static zero(): Division {
    const zeroValues: ExcludeMethodsDeep<Division> = {
      id: NIL_UUID,
      name: '',
      markets: [],
    };
    return new Division(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type DivisionWireFormat = {
  id: string;
  name: string;
  markets: MarketSummaryWireFormat[];
};

type NewDivisionProps = PartialDeep<Division, { recurseIntoArrays: true }>;
export const NewDivision: (props: NewDivisionProps) => Division = (props) => new Division(props);

type NewDivisionFromWireFormatProps = PartialDeep<DivisionWireFormat, { recurseIntoArrays: true }>;
export const NewDivisionFromWireFormat: (props: NewDivisionFromWireFormatProps) => Division = (
  props,
) => new Division(props);
